import $ from 'jquery';

// Handles State Indicator Config UI initialization.
// The #pmp_configurations_ui element carries all required config as data-* attributes.
$(document).ready(function() {
  const uiContainer = document.getElementById('pmp_configurations_ui');
  if (!uiContainer) return;

  const d = uiContainer.dataset;

  if (window.initStateConfigUI) {
    const config = {
      token:      d.token,
      state_code: d.stateCode,
      email:      d.email,
      host:       d.host,
      platform:   "gateway",
    };

    window.initStateConfigUI(uiContainer, config).catch(function(e) {
      const container = document.createElement('div');
      container.className = 'jumbotron';

      const heading = document.createElement('h2');
      heading.textContent = 'Error initiating pmp_configurations_ui assets.';
      container.appendChild(heading);

      e.stack.split('\n').forEach(function(line) {
        const p = document.createElement('p');
        p.style.cssText = 'overflow-wrap: break-word; font-size: 12px';
        p.textContent = '¶  ' + line;
        container.appendChild(p);
      });

      uiContainer.innerHTML = '';
      uiContainer.appendChild(container);
    });
  } else {
    uiContainer.innerHTML =
      "<div class='jumbotron'>" +
      "<h2>Error</h2>" +
      "<p>There was an error retrieving the State Indicator Configuration assets.</p>" +
      "<p>Please check the logs for errors and/or network connect errors.</p>" +
      "</div>";
  }
});
